<template>
  <div class="ai-config-container">
    <el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabClick">
      <el-tab-pane label="模型配置" name="model">
        <AiModelList ref="modelList" />
      </el-tab-pane>
      <el-tab-pane label="功能设置" name="settings">
        <AiGlobalSettings ref="globalSettings" />
      </el-tab-pane>
      <el-tab-pane label="Dify配置管理" name="dify">
        <AiDifyConfig ref="difyConfig" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AiModelList from './ai/ModelList'
import AiGlobalSettings from './ai/GlobalSettings'
import AiDifyConfig from './ai/DifyConfig'

export default {
  name: 'SystemAiConfig',
  components: {
    AiModelList,
    AiGlobalSettings,
    AiDifyConfig
  },
  data () {
    return {
      activeTab: 'model'
    }
  },
  methods: {
    handleTabClick (tab) {
      if (tab.name === 'settings') {
        // 切换到设置页时刷新数据
        this.$nextTick(() => {
          this.$refs.globalSettings.initData()
        })
      } else if (tab.name === 'dify') {
        this.$nextTick(() => {
          this.$refs.difyConfig.loadConfig()
        })
      } else if (tab.name === 'model') {
        // 切换回列表时也可以选择刷新，或者保持状态
        // this.$refs.modelList.search()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ai-config-container {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px); // 减去头部高度

  ::v-deep .el-tabs__content {
    padding: 20px;
    min-height: 500px;
  }
}
</style>
